import cn from 'classnames';
import { memo } from 'react';
import * as sharedStyles from '@shared/styles/sharedStyles.module.scss';
import { ButtonAdd } from '@shared/ui/buttons/button-add/index';
import { FormFieldWithLabel } from '@shared/ui/forms/FieldWithLabel/index';
import type { FormFieldWithLabelPT } from '@shared/ui/forms/FieldWithLabel/ui';
import { Card } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

type FormFieldWithLabelAndPlusBtnPT = FormFieldWithLabelPT & {
  onBtnClick: () => void;
  withBigButton?: boolean;
};
export const FormFieldWithLabelAndPlusBtn = memo(
  ({ onBtnClick, withBigButton, children, ...props }: FormFieldWithLabelAndPlusBtnPT) => {
    const isRequired = props?.requiredField || props?.error?.type === 'optionality';
    return (
      <FormFieldWithLabel
        labelChildren={
          withBigButton ? undefined : (
            <ButtonAdd className={st.smallButton} onClick={onBtnClick} variant="white" />
          )
        }
        {...props}
      >
        {withBigButton ? (
          <Card
            className={cn(sharedStyles.card10, st.bigButton, isRequired && st.required)}
            onClick={onBtnClick}
          >
            <ButtonAdd onClick={onBtnClick} /> <span>Добавить</span>
          </Card>
        ) : (
          children
        )}
      </FormFieldWithLabel>
    );
  }
);
